import { CLIENT_NUTRITION_STATUS_ARCHIVED } from "../../Firestore/nutrition/nutritionPaths";
import { createNutritionPlanActionIncompleteError } from "../plans/nutritionPlanActionSnapshot";
import { getNutritionPlanDisplayNameFromSources } from "../plans/nutritionPlanNameUtils";

export function resolveNutritionPlanPdfSourceName(plan, language = "en") {
  return getNutritionPlanDisplayNameFromSources(
    [
      plan?.planEntity?.getDraftSnapshot?.(),
      plan?.planEntity,
      plan?.rootRecord,
      plan,
    ],
    language,
  );
}

export function resolveActivePlansForPdfExport({
  plans = [],
  orderedActivePlans,
} = {}) {
  if (Array.isArray(orderedActivePlans)) {
    return orderedActivePlans.filter(Boolean);
  }

  return (Array.isArray(plans) ? plans : []).filter(
    (plan) =>
      String(plan?.status ?? "").trim() !== CLIENT_NUTRITION_STATUS_ARCHIVED,
  );
}

export function buildActivePlansPdfExportPlanSources({
  activePlans = [],
  settledSources = [],
  language = "en",
} = {}) {
  const planSources = [];
  const failedPlanNames = [];

  (Array.isArray(activePlans) ? activePlans : []).forEach((plan, index) => {
    const result = Array.isArray(settledSources) ? settledSources[index] : null;

    if (result?.status === "fulfilled") {
      planSources.push(result.value);
      return;
    }

    failedPlanNames.push(resolveNutritionPlanPdfSourceName(plan, language));
  });

  if (failedPlanNames.length > 0) {
    throw createNutritionPlanActionIncompleteError({
      planNames: failedPlanNames,
      reason: "batch_export_incomplete",
    });
  }

  return planSources;
}
